import sc from 'web/components/styled';
import formDescription from './formDescription.css';

const FormDescription = sc.div(formDescription);
FormDescription.displayName = 'FormDescription';

export default FormDescription;
